import { QueryEntity } from '@datorama/akita';
import { NotificationsState, NotificationsStore } from './notifications.store';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class NotificationsQuery extends QueryEntity<NotificationsState> {
	totalUnread = this.select(state => state.ui.totalUnread);
	total = this.select(state => state.ui.total);

	constructor(protected store: NotificationsStore) {
		super(store);
	}
}